
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/connections",
      function () {
        return require("private-next-pages/connections/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/connections"])
      });
    }
  